const TITLE_TO_GENDER = {
    Mr: '1',
    Mrs: '2',
    Mx: '3',
    Pns: '4',
};

const GENDER_TO_TITLE = {
    1: 'Mr',
    2: 'Mrs',
    3: 'Mx',
    4: 'Pns',
};

class mGender extends HTMLSelectElement {
    constructor() {
        super();
        this.titleSelectEl = null;
    }

    connectedCallback() {
        this.titleSelectEl = document.getElementById(this.dataset.titleId);
        if (!this.titleSelectEl) {
            throw new Error('Missing title select element');
        }

        // Event bindings
        this.titleSelectEl.addEventListener('change', this.onTitleChange.bind(this));
        this.addEventListener('change', this.onGenderChange.bind(this));
        this.onTitleChange();
    }

    changeSelectValue(selectEl, newValue) {
        if (selectEl.value !== newValue) {
            selectEl.value = newValue;
            selectEl.dispatchEvent(new Event('change'));
        }
    }

    onGenderChange() {
        const selectedGender = this.value;
        let newTitle = '';

        if (selectedGender) {
            newTitle = GENDER_TO_TITLE[selectedGender] || selectedGender;
        }
        this.changeSelectValue(this.titleSelectEl, newTitle);
    }

    onTitleChange() {
        const selectedTitle = this.titleSelectEl.value;
        let newGender = '';

        if (selectedTitle) {
            newGender = TITLE_TO_GENDER[selectedTitle] || selectedTitle;
        }
        this.changeSelectValue(this, newGender);
    }
}

customElements.define('m-gender', mGender, {
    extends: 'select',
});
